function validator() {

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());

    }
    const validatePassword = password => {

        const re = /[0-9a-zA-Z!@#$%^&*]{6,15}$/
        /*
          (?=.*[0-9]) - строка содержит хотя бы одно число;
          (?=.*[!@#$%^&*]) - строка содержит хотя бы один спецсимвол;
          (?=.*[a-z]) - строка содержит хотя бы одну латинскую букву в нижнем регистре;
          (?=.*[A-Z]) - строка содержит хотя бы одну латинскую букву в верхнем регистре;
          [0-9a-zA-Z!@#$%^&*]{6,} - строка состоит не менее, чем из 6 вышеупомянутых символов.

        */
        return re.test(String(password));
    }

    return {validateEmail, validatePassword}
}

export default validator

